<template>
        <div>
            <v-cookie></v-cookie>
            <div class="place">
                <span>位置：</span>
                <ul class="placeul">
                    <li>首页</li>
                    <li>云电销</li>
                    <li>发起云电销</li>
                </ul>
            </div>
            <div class="formbody">
                <div id="usual1" class="usual"> 
                      <div class="formbody">
                        <el-input type="text" v-model="txtpath" v-show="false" />
                        <el-input type="text" v-model="format" v-show="false" />
                        <div class="formtitle"><span>发起云电销</span></div>
                        <ul class="forminfo">    
                             
                            <li>
                                <label>接收号<b>**</b></label>
                                <textarea name="" v-model="mobile" cols="" rows="" class="textinput left maringht10" style="overflow-y:auto;height:50px;" placeholder="5000个以上号码推荐txt文件导入（txt记事本格式文本一行一个号码）；在线填写或复制粘贴限5000个以内号码，号码间需以空格 或分号；或逗号，相隔；或一行一个号码；">
    
                                </textarea>
                            </li>    
                            <li>
                                <label> &nbsp; </label>
                                <div class="buttonupload  click maringht10" @click="addTxl()"> 通讯录添加 </div> 
                                <div style="float: left; padding-right: 10px;"> 
                                    <el-upload
                                        class="upload-demo"
                                        :on-success="uploadSuccess"
                                        :action=smsTxtUploadUrl
                                        accept=".txt" 
                                        :show-file-list="false"
                                        :before-upload="beforeUploadTxt"
                                        :headers="uploadHeaders"
                                        :on-change="handleChange">
                                        <el-button size="small" type="primary">点击文件导入（txt记事本格式）</el-button>
                                    </el-upload> 
                                </div>
                            </li>
                            <li>
                                <label>发送方式<b>**</b></label>
                                <el-select v-model="timingtype" @change="onSelectChange">
                                    <el-option label="立即发送" value="0"></el-option>
                                    <el-option label="定时发送" value="1"></el-option>
                                </el-select>
                                <el-date-picker
                                    v-model="sendday"
                                    type="date"
                                    :picker-options="startDayPicker"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期" v-if="isShow">
                                </el-date-picker>
                                <el-time-select
                                    v-model="sendhour"
                                    :picker-options="{
                                        start: '08:00',
                                        step: '00:30',
                                        end: '18:00'
                                    }"
                                    placeholder="小时" v-if="isShow">
                                </el-time-select>
                            </li>    
                            
        
                            <li><label>&nbsp;</label><input class="sure"  type="button" @click="sendMarketVoice()" value=" 提交 ">
                            </li>
                        </ul>
                    </div> 
                </div> 
            </div>
    
            <!--tip1 通讯录-->
            <div class="tip tip1">        
                <div class="tiptop"><span>第二办公室-通讯录</span><a></a></div>        
                <div class="tipinfo cen ovhi">      
                    <div class="cen ovhi">
                        <label class="left lh33">选择组 &nbsp; </label>
                        <div class="cityleft">
                            <el-select v-model="txlgroupid" @change="pageChangeTxl()" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option
                                    v-for="item in txlGroupList"
                                    :key="item.groupid"
                                    :label="item.groupname"
                                    :value="item.groupid">
                                </el-option>
                            </el-select>
                        </div>
                    </div>        
                    <table class="tablelist">
                        <thead>
                            <tr>
                                <th>
                                    <input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/>
                                </th>
                                <th>姓名</th>
                                <th>号码</th>
                            </tr>
                        </thead>
                        <tbody>    
                            <tr>
                                <td colspan="3" v-show="isSearch">查询中....</td>
                            </tr>    
                            <tr v-for="item in txlContList">
                                <td><input name="txlmphone1" type="checkbox" :value="item.name + '{'+item.mphone1.trim()+'}'" /></td>
                                <td>{{item.name}}</td>
                                <td>{{item.mphone1}}</td>
                            </tr>
                        </tbody>
                    </table>        
                    <div class="cen pat20 ovhi">
                        <input name="" type="button"  class="sure" @click="checkok()"  value="确定" />&nbsp;
                        <input name="" type="button"  class="cancel" @click="close()"  value="取消" />
                    </div>    
                </div>    
            </div>
            <!--tip1 end-->
    
                
            
            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                    top: 0; left: 0;display: block;" v-show="loadingShow"></div>
                <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                    -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                    <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                    <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">短信提交中,请稍后...</span></div>
                </div>
            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="uploadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="uploadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">文件上传中,请稍后...</span></div>
            </div>
    
            
        </div>
    </template>
    <script>
    import cookie from '@/components/cookie.vue'
    import { delCookie } from '@/assets/js/cookie.js'
    export default {
        components : {
            'v-cookie' : cookie,
        },
        data(){
            return{
                mobile:'',
                txtpath:'',
                format:'phone',
                smsTxtUploadUrl:this.GLOBAL.serverSrc + '/sms/uploadsmstxt.json',
                uploadHeaders:{},
                srcfilename:'',
                account: '',
                txlGroupList:[],
                txlgroupid:'',
                txlContList:[],
                isSearch:true,
                uploadingShow:false,
                smsContTxtList:[],
                pageIndex:0,
                totalCount:0,
                loadingShow:false,
                timingtype:"0",
                sendhour:'',
                sendday:'',
                startDayPicker:{
                    disabledDate(time) {
                　　　　return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                　　}
                },
                isShow:false,
                sendtime:'',
            }
        },
        mounted(){
            this.uploadHeaders.token = this.GLOBAL.token;
            //this.setDate();
        },
        methods:{
            setDate(){
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hours = date.getHours(); //存储时
                var minutes = date.getMinutes(); //存储分
                var shours = '';
                var smiutes = '';
                if(minutes >= 30)
                {
                    hours = hours + 1;
                    minutes = 0;
                }
                else
                {
                    minutes = 30;
                }
                if(hours < 10)
                {
                    shours = '30';
                }
                else
                {
                    shours = hours;
                }
                if(minutes > 10)
                {
                    smiutes = minutes;
                }
                else
                {
                    smiutes = '0' + minutes;
                }
                this.sendhour = shours + ":" + smiutes;
                
                this.sendday = year + "-" + (month >=10 ? month : ('0' + month)) + "-" + (day >=10 ? day : ('0' + day));
            },
            addTxl(){
                $(".tip1").fadeIn(200);
                $(".tiptop a").click(function(){
                    $(".tip1").fadeOut(200);
                })
                this.pageChangeTxl();
            },
            pageChangeTxl(){
                var that = this
                let data = {'groupid':this.txlgroupid}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/txl/gettxlcontmphone.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.txlContList = res.data.txlContList;
                        that.txlGroupList = res.data.txlGroupList;
                        that.isSearch = false;
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
                // checkok();
                
            },
            changAllCheck(){
                var checkers = document.getElementsByName('txlmphone1');
                if (document.getElementById("allCheck").checked == true)
                {
                    for ( var i = 0; i < checkers.length; i++)
                    {
                        checkers[i].checked = true;
                    }
                }
                else
                {
                    for ( var i = 0; i < checkers.length; i++)
                    {
                        checkers[i].checked = false;
                    }
                }
            },
            checkok(){
                var info = '';
                var checkers = document.getElementsByName('txlmphone1');
                for ( var i = 0; i < checkers.length; i++){
                    if(checkers[i].checked){
                        if(info =='')
                            info = checkers[i].value.trim();
                        else
                            info = info + ',' + checkers[i].value.trim();
                    }
                }
                this.mobile = info.trim();
                this.closeTxl();
            },
            closeTxl(){
                $(".tip1").fadeOut(200);
            },
            uploadSuccess(response){
                // console.log(response);
                if (response.code === '0000000') {
                    if(response.mobileNum == 0)
                    {
                        alert("对不起，号码文件为空，请重新上传！");
                    }
                    else
                    {
                        this.txtpath = response.txtPath;
                        this.format = "txt";
                        this.srcfilename = response.srcFileName;
                        this.mobile = "您的号码文件" + response.srcFileName + "上传成功，请填写内容发送."
                    }
                    
                }
                else if("0000006" == response.code){
                    // this.buttonDisabled = false
                    this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                        confirmButtonText: '确定'
                    })
                    this.$refs.upload.clearFiles()
                }
                else{
                    // console.log(JSON.stringify(response.data))
                }
                this.uploadingShow = false;
            },
            handleChange(file, fileList) {
                
            },
            gotoGeXing(){
                location.href = "/smsgexing"
            },
            addSmsContTxt(){
                $(".tip2").fadeIn(200);
                $(".tiptop a").click(function(){
                    $(".tip2").fadeOut(200);
                })
                this.sctfile = '';
                this.pageChangeSCT(1);
            },
            pageChangeSCT(pageIndex){
                let that = this;
                let data = {'pageIndex':pageIndex,'pageSize':50};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/smsconttxt.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.smsContTxtList = res.data.smsContTxtList;
                        that.pageIndex = parseInt(pageIndex);
                        that.totalCount = res.data.page.totalCount;
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            },
            handleCurrentChange(val){
                this.pageChangeSCT(val);
            },
            closesct(){
                $(".tip2").fadeOut(200);
            },
            closetip3(){
                $(".tip3").fadeOut(200);
            },
            beforeUploadTxt(file){
                if (['text/plain'].indexOf(file.type) == -1) {
                    this.$message.error('请上传正确的记事本格式');
                    return false;
                }
                this.uploadingShow = true;
            },
            sendMarketVoice(){
                let descNum = '';
                if(this.mobile.trim() == '')
                {
                    this.$message.error('接收号不能为空');
                    return false;
                }
                if(this.mobile.indexOf("上传成功")==-1)
                {
                    this.format = 'phone';
                    this.txtpath = '';
                    descNum = this.mobile;
                }
                else
                {
                    descNum = this.txtpath;
                }
                if(this.timingtype == 1)
                {
                    this.sendtime = this.sendday + " " + this.sendhour + ":00";
                }
                else
                {
                    this.sendtime = '';
                }
                //console.log(this.format + ":" + this.mobile + "," + this.txtpath);
                let that = this;
                let data = {'format':this.format,'descNum':descNum,'timingtype':this.timingtype,'sendtime':this.sendtime};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/marketvoice/sendmarketvoice.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    //console.log(JSON.stringify(res.data));
                    if('0000000' == res.data.code)
                    {
                        alert("提交成功");
                        // this.$message.error('请上传正确的记事本格式');
                    }
                    else if(res.data.code == '0070005')
                    {
                        alert('费用预扣失败');
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            },
            onSelectChange(){
                if(this.timingtype == 0)
                {
                    this.isShow = false;
                }
                else{
                    this.isShow = true;
                    this.setDate();
                }
            }
        }
    }
    </script>
    


// WEBPACK FOOTER //
// src/components/marketvoice/sendmarketvoice.vue